import { motion } from "framer-motion";
import { EASE_OUT } from "@/lib/scroll";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE_OUT }}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "105%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, delay: d, ease: [0.76, 0, 0.24, 1] } }),
};

export const MaskLines = ({ lines, className = "", delay = 0, inView = false }) => {
  const anim = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...anim}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span className="block" variants={lineVariants} custom={delay + i * 0.12}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Eyebrow = ({ index, children }) => (
  <div className="font-mono-uc text-xs uppercase tracking-[0.25em] text-cyan-300 flex items-center gap-3">
    <span className="text-slate-400">[{index}]</span>
    <span className="h-px w-8 bg-cyan-300/60" />
    <span>{children}</span>
  </div>
);
